import { CmsComponents } from '../ComponentRecognizer/ComponentRecognizer';
import type { CmsData, MenuType } from '../../../interfaces';
import { registerFlexibleComponents } from '../ComponentRecognizer/registerFlexibleComponents';
import { ContentWithMenu } from './ContentWithMenu.client';
import { SchemaOrg } from '../SchemaOrg/SchemaOrg';
import { ClientRegistration } from './ClientRegistration.client';

export const Content = ({
  data,
  menuData,
  token,
}: {
  data: CmsData;
  menuData?: MenuType;
  token?: string;
}) => {
  // Register components for server-side rendering (guarded to run only once)
  registerFlexibleComponents();
  const pageTemplate = data.type === 'storefront_content' ? 'homepage' : 'ServiceUndHilfe';
  if (menuData) {
    return (
      <>
        <ClientRegistration />
        <SchemaOrg data={data} />
        <ContentWithMenu menuData={menuData} currentPath={data.path?.[0].alias}>
          <CmsComponents paragraphs={data.paragraph} pageTemplate={pageTemplate} token={token} />
        </ContentWithMenu>
      </>
    );
  }

  return (
    <>
      <ClientRegistration />
      <SchemaOrg data={data} />
      <CmsComponents paragraphs={data.paragraph} pageTemplate={pageTemplate} token={token} />
    </>
  );
};
